import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function login (username, password) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: 'api/login/authenticateWeb',
      method: 'POST',
      data: {
        Username: username,
        Password: password
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { login }
